function chartKpis() {
    return {
        componentName: 'chartKpi',
        baseStyle: {
            cursor: 'pointer'
        },
        variants: {
            disabled: {
                opacity: 0.4
            }
        }
    };
}

export { chartKpis as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhcnRLcGkuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9jb21wb25lbnRzL2NoYXJ0cy9jaGFydEtwaS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDb21wb25lbnRTdHlsZSB9IGZyb20gJy4uLy4uL3R5cGVzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY2hhcnRLcGlzKCk6IENvbXBvbmVudFN0eWxlIHtcbiAgcmV0dXJuIHtcbiAgICBjb21wb25lbnROYW1lOiAnY2hhcnRLcGknLFxuICAgIGJhc2VTdHlsZToge1xuICAgICAgY3Vyc29yOiAncG9pbnRlcidcbiAgICB9LFxuICAgIHZhcmlhbnRzOiB7XG4gICAgICBkaXNhYmxlZDoge1xuICAgICAgICBvcGFjaXR5OiAwLjRcbiAgICAgIH1cbiAgICB9XG4gIH07XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRWMsU0FBVSxTQUFTLEdBQUE7SUFDL0IsT0FBTztBQUNMLFFBQUEsYUFBYSxFQUFFLFVBQVU7QUFDekIsUUFBQSxTQUFTLEVBQUU7QUFDVCxZQUFBLE1BQU0sRUFBRSxTQUFTO0FBQ2xCLFNBQUE7QUFDRCxRQUFBLFFBQVEsRUFBRTtBQUNSLFlBQUEsUUFBUSxFQUFFO0FBQ1IsZ0JBQUEsT0FBTyxFQUFFLEdBQUc7QUFDYixhQUFBO0FBQ0YsU0FBQTtLQUNGLENBQUM7QUFDSjs7OzsifQ==
